var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04139 1.23465L20.7199 0L32.3983 1.23465L41.4397 13.3719L20.7199 37.5L0 13.3719L9.04139 1.23465Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39258 13.3721L20.7199 37.5001L0 13.3721H8.39258Z",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0469 13.3721L20.7196 37.5001L41.4395 13.3721H33.0469Z",
    fill: "#EA6C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39258 13.3721H33.0472L20.7199 37.5001L8.39258 13.3721Z",
    fill: "#FDAD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7199 0L9.04136 1.23464L8.39258 13.3719L20.7199 0Z",
    fill: "#FDD231"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7196 0L32.3981 1.23464L33.0469 13.3719L20.7196 0Z",
    fill: "#FDD231"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4395 13.3717L32.398 1.23438L33.0469 13.3717H41.4395Z",
    fill: "#FDAD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3717L9.04136 1.23438L8.39258 13.3717H0Z",
    fill: "#FDAD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7199 0L8.39258 13.3719H33.0472L20.7199 0Z",
    fill: "#FEEEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.d5c50de15fedafb2dff12b5a9acf6bf2.svg";
export { ForwardRef as ReactComponent };